import React, { Fragment } from "react";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { sortAlphabetically } from "../../../../utilities/general";

export function TableColConfigDropdown({
  updatePref,
  handleInputChange,
  checkStatuses,
}) {
  var { tCommon: t } = useAppTranslation.Common();
  var { tClients } = useAppTranslation.Clients();
  var LABELS = {
    firstName: "First Name",
    lastName: "Last Name",
    phoneNumber: "Phone Number",
    email: "Email",
    dob: "DOB",
    gender: "Gender",
    sexOnBirth: "Sex at Birth",
    portalStatus: `${t("label.patient")} Portal Status`,
    patientId: `${t("label.patient")} ID`,
    profilePhoto: "Profile Photo",
    phoneNumber2: "Phone 2",
    address1: "Address Line 1",
    address2: "Address Line 2",
    city: "City",
    state: "State",
    zipcode: "Zip#",
    country: "Country",
    lastVisit: "Visited",
    isFired: "Fired",
    nickname: "Nick Name",
    membershipType: "Membership Type",
    totalSalesRelationship: "Total Sales Relationship",
    referralSource: "Referral Source",
    createdAt: tClients("all.patientCreationDate"),
    upcomingAppointments: tClients("all.filter.upcomingAppointment"),
  };

  var sortableItems = [
    {
      sortLabel: LABELS.patientId,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.patientId ? "checked" : false}
            type="checkbox"
            id="patient_id"
            name="patient_id"
          />{" "}
          <label htmlFor="patient_id">{LABELS.patientId}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.profilePhoto,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.profilePhoto ? "checked" : false}
            type="checkbox"
            id="user_image"
            name="user_image"
          />{" "}
          <label htmlFor="user_image">{LABELS.profilePhoto}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.phoneNumber2,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.phoneNumber2 ? "checked" : false}
            type="checkbox"
            id="phoneNumber_2"
            name="phoneNumber_2"
          />{" "}
          <label htmlFor="phoneNumber_2">{LABELS.phoneNumber2}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.address1,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.address1 ? "checked" : false}
            type="checkbox"
            id="address_line_1"
            name="address_line_1"
          />{" "}
          <label htmlFor="address_line_1">{LABELS.address1}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.address2,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.address2 ? "checked" : false}
            type="checkbox"
            id="address_line_2"
            name="address_line_2"
          />{" "}
          <label htmlFor="address_line_2">{LABELS.address2}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.city,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.city ? "checked" : false}
            type="checkbox"
            id="city"
            name="city"
          />{" "}
          <label htmlFor="city">{LABELS.city}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.state,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.state ? "checked" : false}
            type="checkbox"
            id="state"
            name="state"
          />{" "}
          <label htmlFor="state">{LABELS.state}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.zipcode,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.zipcode ? "checked" : false}
            type="checkbox"
            id="zipcode"
            name="zipcode"
          />{" "}
          <label htmlFor="zipcode">{LABELS.zipcode}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.country,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.country ? "checked" : false}
            type="checkbox"
            id="country"
            name="country"
          />{" "}
          <label htmlFor="country">{LABELS.country}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.lastVisit,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.lastVisit ? "checked" : false}
            type="checkbox"
            id="last_visit"
            name="last_visit"
          />{" "}
          <label htmlFor="last_visit">{LABELS.lastVisit}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.isFired,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.isFired ? "checked" : false}
            type="checkbox"
            id="is_fired"
            name="is_fired"
          />{" "}
          <label htmlFor="is_fired">{LABELS.isFired}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.nickname,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.nickname ? "checked" : false}
            type="checkbox"
            id="nick_name"
            name="nick_name"
          />{" "}
          <label htmlFor="nick_name">{LABELS.nickname}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.membershipType,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.isMonthlyMembership ? "checked" : false}
            type="checkbox"
            id="is_monthly_membership"
            name="is_monthly_membership"
          />{" "}
          <label htmlFor="is_monthly_membership">{LABELS.membershipType}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.totalSalesRelationship,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.totalSalesRelationship ? "checked" : false}
            type="checkbox"
            id="total_sale_relationship"
            name="total_sale_relationship"
          />{" "}
          <label htmlFor="total_sale_relationship">
            {LABELS.totalSalesRelationship}
          </label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.referralSource,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.referralSource ? "checked" : false}
            type="checkbox"
            id="referral_source"
            name="referral_source"
          />{" "}
          <label htmlFor="referral_source">{LABELS.referralSource}</label>
        </li>
      ),
    },
    {
      sortLabel: LABELS.createdAt,
      component: (
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.createdAt ? "checked" : false}
            type="checkbox"
            id="client_created_date"
            name="client_created_date"
          />{" "}
          <label htmlFor="client_created_date">{LABELS.createdAt}</label>
        </li>
      ),
    },
  ];

  sortableItems.sort(sortAlphabetically("sortLabel"));

  return (
    <div className="dropdown add-field profile-toggler">
      <button className="dropdown-toggle" type="button" data-toggle="dropdown">
        {" "}
        +
      </button>
      <ul className="dropdown-menu add-field-list min-width-205">
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            type="checkbox"
            id="firstname"
            name="firstname"
            defaultChecked="checked"
            disabled="disabled"
          />{" "}
          <label htmlFor="firstname">{LABELS.firstName}</label>
        </li>
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            type="checkbox"
            id="lastname"
            name="lastname"
            defaultChecked="checked"
            disabled="disabled"
          />{" "}
          <label htmlFor="lastname">{LABELS.lastName}</label>
        </li>
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.phoneNumber ? "checked" : false}
            type="checkbox"
            name="phoneNumber"
          />{" "}
          <label htmlFor="phoneNumber">{LABELS.phoneNumber}</label>
        </li>
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.email ? "checked" : false}
            type="checkbox"
            id="email"
            name="email"
          />{" "}
          <label htmlFor="email">{LABELS.email}</label>
        </li>
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.dob ? "checked" : false}
            type="checkbox"
            id="date_of_birth"
            name="date_of_birth"
          />{" "}
          <label htmlFor="date_of_birth">{LABELS.dob}</label>
        </li>
        <li>
          <input
            type="checkbox"
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.gender ? "checked" : false}
            id="gender"
            name="gender"
          />{" "}
          <label htmlFor="gender">{LABELS.gender}</label>
        </li>
        <li>
          <input
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.upcomingAppointments ? "checked" : false}
            type="checkbox"
            id="upcoming_appointments"
            name="upcoming_appointments"
          />{" "}
          <label htmlFor="upcoming_appointments">
            {LABELS.upcomingAppointments}
          </label>
        </li>
        <li>
          <input
            type="checkbox"
            onClick={updatePref}
            onChange={handleInputChange}
            checked={checkStatuses.portalStatus ? "checked" : false}
            id="access_portal_index"
            name="access_portal_index"
          />{" "}
          <label htmlFor="access_portal_index">{LABELS.portalStatus}</label>
        </li>
        {sortableItems.map((item) => (
          <Fragment key={item.sortLabel}>{item.component}</Fragment>
        ))}
      </ul>
    </div>
  );
}
